import React from 'react';
import { useTranslation } from 'react-i18next';
import { TEXT } from '../../constant/textConstants';
import { ROUTE } from '../../constant/routeConstants';
import { useNavigate, useParams } from 'react-router-dom';
import { generateLocalizedPath } from '../../services/utils';

const Header = ({ title, home, path }) => {
  const { lang } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between gap-4 border-b-[1px] px-3.5 pb-1 pt-8">
      <p className="text-headingSm font-semibold">{title}</p>

      <div
        onClick={() => {
          if (home) {
            navigate(generateLocalizedPath(lang, ROUTE?.DASHBOARD));
          } else {
            navigate(path);
          }
        }}
        className="cursor-pointer text-base font-semibold text-main"
      >
        {t(TEXT?.CLOSE)}
      </div>
    </div>
  );
};

export default Header;
